module.exports = __webpack_public_path__ + "img/utility-bg-header.1810e0f2.webp";